import { Injectable } from '@angular/core';
import { RendererFormCommand } from '@vinnova/formrenderer';
import { map, Observable } from 'rxjs';
import { FormClient } from '../clients/etjanster-common-api/form.client';
import { Publication } from '../models/rapport.model';

@Injectable({ providedIn: 'root' })
export class FormQuery {
  constructor(
    private projektClient: FormClient,
    private rendererFormCommand: RendererFormCommand,
  ) {}

  public getLatestPublication(
    formId: string,
  ): Observable<Publication | undefined> {
    return this.projektClient.getLatestPublication(formId).pipe(
      map((value) => {
        const parsed = value.publicationJson
          ? (JSON.parse(value.publicationJson) as Publication)
          : undefined;
        if (parsed) {
          this.rendererFormCommand.setForm(parsed.form);
          this.rendererFormCommand.setActive(parsed.form.id);
        }
        return parsed;
      }),
    );
  }
}
